import { render } from "./Pagination.vue?vue&type=template&id=18cbae82"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
script.render = render

export default script